import clsx from "clsx";
import classes from "./LoadingButton.module.css";
import { SpinnerGap } from "@phosphor-icons/react";

type Props = {
  loading: boolean;
  title?: any;
  submit?: boolean;
  onClick?: any;
  style?: string;
  size?: any;
  space?: string;
  disabled?: boolean;
  icon?: any;
  form?: any;
};

const LoadingButton: React.FC<Props> = ({
  loading,
  title,
  submit,
  onClick,
  style,
  space,
  size,
  disabled,
  icon,
  form,
}) => {
  return (
    <button
      className={clsx(style ? style : "btn btn-primary", size, space)}
      type={submit ? "submit" : "button"}
      disabled={loading || disabled}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
      form={form ? form : null}
    >
      {loading && <SpinnerGap className={classes.icon} size={16} />}
      {icon}
      {title ? title : null}
    </button>
  );
};

export default LoadingButton;
